import LottiePlayer from './LottiePlayer';
import * as S from './styled/Loading.styled';

const Loading = () => (
	<S.LoadingContainer>
		<S.LottieContainer>
			<LottiePlayer name="loading" />
		</S.LottieContainer>
	</S.LoadingContainer>
);

export default Loading;
